import React, { useState } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown } from "react-bootstrap";
import "./Areaguides.scss";
import moment from "moment/dist/moment";
import { useStaticQuery, graphql } from "gatsby";
import ReactMarkdown from "react-markdown";
import Areguides from "@Components/StaticPage/Explore/Explore";
import { getSrc } from "gatsby-plugin-image"
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";

import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

import {ImageModule} from "@Components/common/Image_Module";


const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const titleVariants = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        delay: 1.5,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 1
        }
    }
}

const contentVariants = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        delay: 2,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 1
        }
    }
}

const FilterGallery = (props) => {
    const areablock = props.modules;
    const data = useStaticQuery(graphql`
    query{
      glstrapi {
        areas {
          id
          imagetransforms
          ggfx_results {
            id
            content_type
            transforms
            src_import_url
            src_cftle
            field
          }
          Name
          URL
          Select_Category    
          Tile_image {
          url
          }
        }
      }
    }
    `);
    const [areas, setareas] = useState(data.glstrapi?.areas)


    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => {
                return (
                    <motion.section
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        variants={containerVariants}
                    >
                        <React.Fragment>
                            <section className="offices-section guides-section">
                                <Container>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="content-how-can-we-help">
                                                <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                                    <motion.div variants={titleVariants}>
                                                        <h2><span className="stroke-text">{props.Title}</span>{props.Sub_Title}</h2>
                                                    </motion.div>
                                                </ScrollAnimation>

                                                <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                                    <motion.div variants={titleVariants}>
                                                        <ReactMarkdown source={props.Content} allowDangerousHtml />
                                                    </motion.div>
                                                </ScrollAnimation>

                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg={6} className="d-flex">
                                            <motion.div variants={contentVariants}>
                                                <div className="person-detail">
                                                    <div className="box">
                                                        <div class="office-bk">
                                                            {/* <picture>
                                        <source media="(min-width:992px)" srcSet={areablock.Areaguide_Block1_Image?.url} />
                                        <source media="(min-width:768px)" srcSet={areablock.Areaguide_Block1_Image?.url} />
                                        <img src={areablock.Areaguide_Block1_Image?.url} alt="" />
                                    </picture> */}
                                                            <img src={getSrc(areablock.Areaguide_Block1_Image?.url_sharp)} alt={areablock.Areaguide_Block1_Image?.alternativeText} />
                                                        </div>
                                                        <div className="area-block">
                                                            <ScrollAnimation animateOnce={true} animateIn="fadeInDown">
                                                                <h3>{areablock.Areaguide_Block1_Title}</h3>
                                                            </ScrollAnimation>
                                                            <ScrollAnimation animateOnce={true} animateIn="fadeInDown">
                                                                <ReactMarkdown source={areablock.Areaguide_Block1_Content} allowDangerousHtml />
                                                            </ScrollAnimation>
                                                            <ul>
                                                                {areas.map(list => {
                                                                    let processedImages = JSON.stringify({});
                                                                    if (list?.imagetransforms?.Image_Transforms) {
                                                                        processedImages = list.imagetransforms.Image_Transforms;
                                                                    }
                                                                    return <>
                                                                        {list.Select_Category === "Oxford" &&
                                                                            <>
                                                                                <li>
                                                                                    <ScrollAnimation animateOnce={true} animateIn="fadeInDown">
                                                                                        <Link to={`/about/our-areas/${list.URL}`}>
                                                                                            <div className="small_circle">
                                                                                                {/* <img src={list.Tile_image.url} /> */}
                                                                                                <ImageModule ImageSrc={list.Tile_image} attr={{ alt: list.Name }} ggfx_results={list.ggfx_results} imagename="areas.Image.circle" strapi_id={list.id} />

                                                                                                {/* <ImageTransform imagesources={list.Tile_image?.url} renderer="srcSet" imagename='areas.Image.circle'
                                                                                                    attr={{ alt: list.Tile_image?.alternativeText, className: '' }}
                                                                                                    imagetransformresult={processedImages} id={list.id} >

                                                                                                </ImageTransform> */}
                                                                                            </div>
                                                                                            <span>{list.Name}</span>
                                                                                        </Link>
                                                                                    </ScrollAnimation>
                                                                                </li>
                                                                            </>
                                                                        }
                                                                    </>
                                                                })}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </motion.div>
                                        </Col>

                                        <Col lg={6} className="d-flex">
                                            <motion.div variants={contentVariants}>
                                                <div className="person-detail">
                                                    <div className="box">
                                                        <div class="office-bk">
                                                            {/* <picture>
                                        <source media="(min-width:992px)" srcSet={areablock.Areaguide_Block2_Image?.url} />
                                        <source media="(min-width:768px)" srcSet={areablock.Areaguide_Block2_Image?.url} />
                                        <img src={areablock.Areaguide_Block2_Image?.url} alt="" />
                                    </picture> */}
                                                            <img src={getSrc(areablock.Areaguide_Block2_Image?.url_sharp)} alt={areablock.Areaguide_Block2_Image?.alternativeText} />
                                                        </div>
                                                        <div className="area-block">
                                                            <ScrollAnimation animateOnce={true} animateIn="fadeInDown">
                                                                <h3>{areablock.Areaguide_Block2_Title}</h3>
                                                            </ScrollAnimation>
                                                            <ScrollAnimation animateOnce={true} animateIn="fadeInDown">
                                                                <ReactMarkdown source={areablock.Areaguide_Block2_Content} allowDangerousHtml />
                                                            </ScrollAnimation>
                                                            <ul>
                                                                {areas.map(list => {
                                                                    return <>
                                                                        {list.Select_Category === "Thame" &&
                                                                            <>
                                                                                <li>
                                                                                    <ScrollAnimation animateOnce={true} animateIn="fadeInDown">
                                                                                        <Link to={`/about/our-areas/${list.URL}`}>
                                                                                            <div className="small_circle">
                                                                                                <img src={list.Tile_image.url} />
                                                                                            </div>
                                                                                            <span>{list.Name}</span>
                                                                                        </Link>
                                                                                    </ScrollAnimation>
                                                                                </li>
                                                                            </>
                                                                        }
                                                                    </>
                                                                })}
                                                            </ul>
                                                        </div>

                                                    </div>
                                                </div>
                                            </motion.div>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                        </React.Fragment>
                    </motion.section>
                )
            }}
        </InView>
    )
}

export default FilterGallery;